import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    maxWidth: "700px",
    position: "relative",
    height: "100vh",
    fontSize: 14,
  },

  wrapper: {
    padding: "16px 16px",
    fontSize: 14,
    minHeight: "calc(100% - 96px)",
    background: "#F3F3F3",
  },

  // contain_3: {
  //   padding: "16px 16px",
  //   fontSize: 14,
  //   minHeight: "calc(100% - 96px)",
  //   background: "white",
  // },

  button_select: {
    width: "100%",
    textTransform: "none",
  },

  textField_search_select: {
    display: "flex !important",
    position: "sticky !important",
    top: 0,
    zIndex: 1,
    background: "white",
    padding: "8px",
  },

  clock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: 14,
    margin: "12px 0",

    "& .icon": {
      width: 20,
      height: 20,
      marginRight: 5,
    },
  },

  selectLine: {
    display: "flex",
    justifyContent: "center",

    "& .line": {
      width: "60%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #D2D2D2",
      borderRadius: 40,
      margin: "8px 0px 10px",
      padding: "5px",
      background: "white",
    },

    "& .icon": {
      width: "30px",
    },

    "& .value": {
      fontSize: 16,
      fontWeight: 500,
    },
  },

  box_days: {
    display: "flex",
    justifyContent: "space-around",
    "& .Mui-disabled": { color: "#343A40 !important" },
  },

  box_insu_2: {
    padding: "12px",
    border: "1px solid #D2D2D2",
    borderRadius: "8px",
    background: "white",

    "& .title_edit": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "18px",
      fontWeight: "600",
      color: "#009B4B",
      marginBottom: "12px",
    },

    "& .line_infor": {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "15px",
      color: "#343A40",
    },

    "& .value": {
      fontWeight: "600",
    },
  },

  note: {
    color: "#B06B03",
    background: "#FDF8E4",
    padding: "10px",
    fontSize: "13px",
    textAlign: "justify",
    lineHeight: "140%"
  },

  box_infor_user: {
    margin: "12px 0",

    "& .text_note_radio": {
      fontSize: "14px",
      color: "#FB7800",
      lineHeight: "21px",
    },
  },

  box_benefit_3: {
    padding: "12px",
    // border: "1px solid #D2D2D2",
    borderRadius: "8px",
    background: "white",

    "& .title_edit": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "600",
      color: "#343A40",
      marginBottom: "12px",
      borderBottom: "1.5px solid #D2D2D2",
    },

    "& .name_program": {
      fontSize: "15px",
      fontWeight: "600",
      color: "#009B4B",
      marginBottom: "12px",
    },

    "& .quyen_loi": {
      width: "100%",
      display: "flex",
      alignItems: "start",
      fontWeight: "600",
      fontSize: "12px",
      marginTop: "12px",
    },

    "& .phi_bh": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "start",
      fontWeight: "600",
      fontSize: "12px",
      marginTop: "12px",
    },

    "& .box_line_fees": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "start",
      fontSize: "13px",
      marginTop: "12px",
      paddingBottom: "8px",
      borderBottom: "1px solid #D2D2D2",

      "& .fees": { fontWeight: "600", color: "#009B4B" },
    },
    "& .box_line_fees_no_border": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "start",
      fontSize: "13px",
      marginTop: "12px",
      paddingBottom: "8px",
      "& .fees": { fontWeight: "600", color: "#009B4B" },
    },
  },

  box_infor_user_3: {
    padding: "12px",
    // border: "1px solid #D2D2D2",
    borderRadius: "8px",
    background: "white",
    marginTop: "12px",

    "& .title_edit": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "600",
      color: "#343A40",
      marginBottom: "12px",
      borderBottom: "1.5px solid #D2D2D2",
    },

    "& .box_line_infor": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "start",
      fontSize: "13px",
      marginTop: "12px",

      "& .fees": { fontWeight: "600" },
    },
  },

  box_infor_bill_3: {
    padding: "12px",
    // border: "1px solid #D2D2D2",
    borderRadius: "8px",
    background: "white",
    marginTop: "12px",

    "& .title": {
      fontSize: "16px",
      fontWeight: "600",
      color: "#009B4B",
      marginBottom: "12px",
    },

    "& .box_line_infor": {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "start",
      fontSize: "13px",
      marginTop: "12px",

      "& .fees": { fontWeight: "600" },
    },
  },

  box_feed_3: {
    padding: "12px",
    borderRadius: "8px",
    background: "#F2FDF4",
    marginTop: "12px",

    "& .row_discoun": {
      display: "flex",
      marginBottom: "12px",
    },

    "& .btn_aply": {
      width: "30%",
      marginLeft: "12px",
      textTransform: "none",
      background: "#FB7800",
      color: "white",
      fontWeight: "600",
      borderRadius: "6px",
    },

    "& .box_fee": {
      padding: "8px",
      border: "1px solid #009B4B",
      borderRadius: "6px",
      background: "white",
      marginBottom: "12px",
    },

    "& .box_discount": {
      padding: "8px",
      border: "1px solid #FB7800",
      borderRadius: "6px",
      background: "white",
      marginBottom: "12px",
    },

    "& .rowTotal": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",

      "& .label-total": {
        fontWeight: "600",
        color: "#383D3B",
      },

      "& .green-total": {
        fontWeight: "600",
        color: "#009B4B",
      },

      "& .origan-total": {
        fontWeight: "600",
        color: "#FB7800",
      },
    },

    "& .m-0": { margin: 0 },
  },

  box_checkbox_3: {
    fontSize: "15px",
    margin: "12px 0",

    "& .dk": {
      display: "flex",
      alignItems: "start",
      marginBottom: "12px",
    },
  },

  redTxt: { color: "red", marginTop: "6px" },

  //
}));
